import { Nullable } from '@enmon/commons';
import { Commodity } from '@enmon/commons/lib/shared';
import { InventoryMeterMountType } from '@enmon/commons/lib/tools';
import { DefaultOptionType } from 'antd/lib/select';
import { meterMountTypeTranslated } from 'components/Form/meter_details/constants';
import { IntlShape } from 'react-intl';

export const getMeterMountTypeSelectOptions = (
  commodity: Nullable<Commodity>,
  intl: IntlShape,
): DefaultOptionType[] => {
  if (!commodity) {
    console.warn('Received empty commodity: ', commodity);
    return [];
  }
  return Object.values(InventoryMeterMountType).map(value => ({
    label: intl.formatMessage(meterMountTypeTranslated[value]),
    value,
  }));
};
